/**
 * Conta o número de diferenças entre dois objetos
 * @param {Object} original - Objeto de filtro original
 * @param {Object} modified - Objeto de filtro modificado
 * @returns {Number} - Total de diferenças encontradas
 */
const countFilterDifferences = (original, modified) => {
    let changeCount = 0;

    // Função auxiliar para comparação profunda de objetos
    const compareObjects = (obj1, obj2, path = '') => {
        // Tratar null/undefined
        if (obj1 === obj2) return;
        if (!obj1 || !obj2) {
            changeCount++;
            return;
        }

        // Se não for objeto ou array, comparar diretamente
        if (typeof obj1 !== 'object' || typeof obj2 !== 'object') {
            if (obj1 !== obj2) {
                changeCount++;
            }
            return;
        }

        // Tratar arrays (compara como uma única entidade)
        if (Array.isArray(obj1) && Array.isArray(obj2)) {
            if (JSON.stringify(obj1) !== JSON.stringify(obj2)) {
                changeCount++;
            }
            return;
        }

        // Tratar objetos aninhados
        const allKeys = [...new Set([...Object.keys(obj1), ...Object.keys(obj2)])];

        allKeys.forEach(key => {
            compareObjects(obj1[key], obj2[key], `${path}.${key}`);
        });
    };

    // Comparar chaves de primeiro nível
    const allKeys = [...new Set([
        ...Object.keys(original || {}),
        ...Object.keys(modified || {})
    ])];

    allKeys.forEach(key => {
        compareObjects(original?.[key], modified?.[key], `.${key}`);
    });

    return changeCount;
};

export default countFilterDifferences;